import { Controller } from "@hotwired/stimulus"

// Live sample-cell updates on the column-mapping table. Loading overlay stays on
// the parent `import` controller wrapping #import-content.
export default class extends Controller {
  static values = {
    samples: Array,
    unitParses: Object,
    contactParses: Object
  }

  updateSamples(event) {
    const select = event.currentTarget
    const row = select.closest("tr")
    if (!row) return

    const colIndex = select.value === "" ? null : Number(select.value)
    const isUnitField = row.dataset.unitField === "true"
    const isContactField = row.dataset.contactField === "true"
    const fieldKey = row.dataset.fieldKey

    row.querySelectorAll("[data-import-mapping-target='sample']").forEach((cell) => {
      const sampleIndex = Number(cell.dataset.sampleIndex)
      const rawEl = cell.querySelector("[data-import-mapping-target='rawSample']")

      if (colIndex === null || Number.isNaN(colIndex)) {
        if (rawEl) rawEl.textContent = ""
        this.clearExtraParse(cell)
        return
      }

      const rowData = this.samplesValue[sampleIndex] || []
      const raw = rowData[colIndex] ?? ""
      if (rawEl) rawEl.textContent = raw

      if (isUnitField) {
        this.fillExtraParse(cell, (this.unitParsesValue[String(colIndex)] || [])[sampleIndex] || [])
      } else if (isContactField) {
        const byCol = (this.contactParsesValue[fieldKey] || {})[String(colIndex)] || []
        this.fillExtraParse(cell, byCol[sampleIndex] || [])
      }
    })
  }

  fillExtraParse(cell, blocks) {
    const container = cell.querySelector("[data-import-mapping-target='extraParse']")
    if (!container) return

    container.replaceChildren()
    ;(blocks || []).forEach((block) => {
      container.appendChild(this.buildBlockElement(block))
    })
  }

  buildBlockElement(block) {
    if (block.empty) {
      const empty = document.createElement("div")
      empty.className = "text-muted"
      empty.textContent = block.message || "—"
      return empty
    }

    const wrap = document.createElement("div")
    wrap.className = "mb-2"

    if (block.title) {
      const title = document.createElement("div")
      title.className = "fw-semibold"
      title.textContent = block.title
      wrap.appendChild(title)
    }

    ;(block.lines || []).forEach((line) => {
      const row = document.createElement("div")
      row.className = "text-break ps-3"
      row.textContent = line
      wrap.appendChild(row)
    })

    return wrap
  }

  clearExtraParse(cell) {
    const container = cell.querySelector("[data-import-mapping-target='extraParse']")
    if (container) container.replaceChildren()
  }
}
